/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// likbraries
import React, {Component} from 'react';

// styles
import injectSheet from 'react-jss';
import styles from 'material/feedback/hubspot/hubspotmodal_styles';



/* ========== ~~~~~~~~~~ CALLOUT : DATA LAST UPDATED ~~~~~~~~~~ ========== */
class HubSpotModal extends Component {
    componentDidMount() {
        const script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/v2.js';
        document.body.appendChild(script);

        script.addEventListener('load', () => {
            if(window.hbspt) {
                window.hbspt.forms.create({
                    region: "na1",
                    portalId: "2536424",
                    formId: "d10e7d9c-57b5-46ac-8573-c41dadee952e",
                    target: '.hubspotForm'
                })
            }
        });
    }
    render(){
        return (
            <div className={`hubspotmodal ${this.props.classes.hubspotmodal}`}>
                <div className="hubspotForm"/>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(HubSpotModal);
